
export const customeDateHandler = (name, value, setState) => {
    setState((prev) => ({ ...prev, [name]: value }));
  };

 export  const customeTimeHandler = (name, value, setState) => {
    setState((prev) => ({ ...prev, [name]: value }));
  };